import { Box, Collapse, Group, Stack, Text, UnstyledButton } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconChevronDown, IconChevronUp, IconInfoCircle } from '@tabler/icons-react';
import { FC } from 'react';

import {
  inAppBrowserWarning,
  isInAppBrowser,
} from '../../utils/geolocation-platform';

import classes from './harvest-proof-intro.module.css';

interface HarvestProofIntroProps {
  accountName?: string;
}

export const HarvestProofIntro: FC<HarvestProofIntroProps> = ({ accountName }) => {
  const [expanded, { toggle }] = useDisclosure(false);
  const showInAppWarning = isInAppBrowser();

  return (
    <Box className={classes.root}>
      {showInAppWarning ? (
        <Text c="orange" mb="sm" size="sm">
          {inAppBrowserWarning()}
        </Text>
      ) : null}
      <UnstyledButton
        aria-expanded={expanded}
        className={classes.toggle}
        onClick={toggle}
        type="button"
      >
        <Group align="flex-start" justify="space-between" wrap="nowrap">
          <Group align="flex-start" gap="sm" wrap="nowrap">
            <Box className={classes.iconWrap}>
              <IconInfoCircle size={22} stroke={1.75} />
            </Box>
            <Stack gap={2}>
              <Text className={classes.title} fw={700} size="lg">
                Preuve de récolte
              </Text>
              {accountName ? (
                <Text c="dimmed" size="sm">
                  {accountName}
                </Text>
              ) : null}
            </Stack>
          </Group>
          <Group className={classes.expandHint} gap={4} wrap="nowrap">
            <Text className={classes.expandLabel} size="sm">
              {expanded ? 'Masquer' : 'En savoir plus'}
            </Text>
            {expanded ? (
              <IconChevronUp aria-hidden size={20} stroke={1.75} />
            ) : (
              <IconChevronDown aria-hidden size={20} stroke={1.75} />
            )}
          </Group>
        </Group>
      </UnstyledButton>

      <Collapse in={expanded}>
        <Stack className={classes.body} gap="sm">
          <Text size="sm">
            Ce formulaire vous permet d’envoyer une photo de récolte pour chaque
            parcelle tournesol ou cameline de votre exploitation.
          </Text>
          <Text size="sm">
            Activez votre position, sélectionnez la parcelle sur la carte, puis
            prenez une photo sur place. La preuve n’est acceptée que si vous
            êtes à proximité immédiate de la parcelle.
          </Text>
          <Text c="dimmed" size="xs">
            En cas de difficulté, contactez votre technicien Saipol.
          </Text>
        </Stack>
      </Collapse>
    </Box>
  );
};
